import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/assets/css/flaticon.css';
import '../src/assets/css/style.css';
import '../src/assets/css/responsive.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import HomePage from './pages/HomePage';
import ContactPage from './pages/Contact';
import AboutPage from './pages/About';
import Layout from './components/Layout';
import routes from './routes';
import Dashboard from './Dashboard/Dashboard';
import UserLayout from './Dashboard/UserLayout';
import Package from './Package/Package';
import PackageCourses from './Package/PackageCourses';
import Payment from './Package/Payment';
import Hold from './Dashboard/Hold';
import AdminLayout from './Admin/AdminLayout';
import Admin from './Admin/Admin';
import EmailConfirmation from './pages/EmailConfirmation';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LoginPrivacyPolicy from './pages/LoginPrivacyPolicy';
import LoginTermsConditions from './pages/LoginTermsConditions';
import Payouts from './Dashboard/Payouts';
import UserProfile from './Dashboard/UserProfile';
import KycUserPannel from './components/KycUserPannel';
import ChangePassword from './components/ChangePassword';
import PackagePaymentRequest from './Admin/PackagePaymentRequest';
import KycDetail from './Admin/KycDetail';
import UserInformation from './Admin/UserInformation';
import WithDrawRequestApproval from './Admin/WithDrawRequestApproval';
import MyCourses from './Dashboard/Courses/MyCourses';
import UpdateUserByAdmin from './Admin/UpdateUserByAdmin';
import ForgetPassword from './components/Forgetpassword';
import UpdateProfile from './Admin/UpdateProfile';
import AdminCourses from './Admin/AdminCourses';
import Courses from './Dashboard/Courses';
import MyWallet from './Dashboard/MyWallet';
import AdminWallet from './Admin/AdminWallet';
import Training from './Dashboard/Training';
import QualityUserInformation from './Admin/QualityUserInformation';
import Support from './components/Support';
import CourseQuestion from './Admin/CourseQuestion';
import CouponCode from './Admin/CouponCode';
import EventAndPayment from './Admin/EventAndPayment';
import Ticket from './Dashboard/Event';
import CustomizedPackageOrder from './Admin/CustomizedPackageOrder';
import UnlistedVideo from './components/UnlistedVideo';
import Certification from './Dashboard/Certification';
import { App as CapacitorApp } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';
import { usePreviousUrl } from "./UsePreviousUrl";
import AdminNotification from './Admin/AdminNotification';
import CertificateValidation from './components/CertificateValidation';
import CertificateBarcode from './components/CertificateBarcode';

function App() {
  const navigate = useNavigate();
  const prevUrl = usePreviousUrl();
  React.useEffect(() => {
    let backButtonListener: any;

    const setupListener = async () => {
      backButtonListener = await CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack && prevUrl !== "/") {
          navigate(-1);   // go back in React Router
        } else {
          CapacitorApp.exitApp(); // exit if no history
        }
      });
    };
    setupListener();
    return () => {
      if (backButtonListener) {
        backButtonListener.remove(); // ✅ works here
      }
    };
  }, [navigate]);
  return (
    <>
      {/* <MaintenancePage /> */}
      <Routes>
        <Route path={routes.home} element={<Layout><HomePage /></Layout>} />
        <Route path={routes.contactUs} element={<Layout><ContactPage /></Layout>} />
        <Route path={routes.aboutUs} element={<Layout><AboutPage /></Layout>} />
        <Route path={"/courses"} element={<Layout><Courses /></Layout>} />
        <Route path={"/privacy-policy"} element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path={"/certificate-verification"} element={<Layout><CertificateValidation /></Layout>} />
        <Route path={"/refund-policy"} element={<Layout><RefundPolicy /></Layout>} />
        <Route path={"/terms"} element={<Layout><TermsConditions /></Layout>} />
        <Route path={"/dashboard"} element={<UserLayout><Dashboard /></UserLayout>} />
        <Route path={"/package"} element={<UserLayout><Package /></UserLayout>} />
        <Route path={"/package-courses"} element={<UserLayout><PackageCourses /></UserLayout>} />
        <Route path={"/hold"} element={<UserLayout><Hold /></UserLayout>} />
        <Route path={"/profile"} element={<UserLayout><UserProfile /></UserLayout>} />
        <Route path={"/kyc"} element={<UserLayout><KycUserPannel /></UserLayout>} />
        <Route path={"/emailConfirmation"} element={<EmailConfirmation />} />
        <Route path={"/privacypolicy"} element={<LoginPrivacyPolicy />} />
        <Route path={"/termsconditions"} element={<LoginTermsConditions />} />
        <Route path={"/payouts"} element={<UserLayout><Payouts /></UserLayout>} />
        <Route path={"/changepassword"} element={<UserLayout><ChangePassword /></UserLayout>} />
        <Route path={"/mycourses"} element={<UserLayout><MyCourses /></UserLayout>} />
        <Route path={"/mywallet"} element={<UserLayout><MyWallet /></UserLayout>} />
        <Route path={"/adminwallet"} element={<AdminLayout><AdminWallet /></AdminLayout>} />
        <Route path={"/admin"} element={<AdminLayout><Admin /></AdminLayout>} />
        <Route path={"/packagepayment"} element={<AdminLayout><PackagePaymentRequest /></AdminLayout>} />
        <Route path={"/kycdetail"} element={<AdminLayout><KycDetail /></AdminLayout>} />
        <Route path={"/userdetail"} element={<AdminLayout><UserInformation /></AdminLayout>} />
        <Route path={"/withdrawrequests"} element={<AdminLayout><WithDrawRequestApproval /></AdminLayout>} />
        <Route path={"/admin"} element={<AdminLayout><Admin /></AdminLayout>} />
        <Route path={"/updateuser"} element={<AdminLayout><UpdateUserByAdmin /></AdminLayout>} />
        <Route path={"/adminchangepassword"} element={<AdminLayout><ChangePassword /></AdminLayout>} />
        <Route path={"/admincourses"} element={<AdminLayout><AdminCourses /></AdminLayout>} />
        <Route path={"/forgetpassword"} element={<ForgetPassword />} />
        <Route path={"/adminprofile"} element={<AdminLayout><UpdateProfile /></AdminLayout>} />
        <Route path={"/qualityUser"} element={<AdminLayout><QualityUserInformation /></AdminLayout>} />
        <Route path={"/courseQuestion"} element={<AdminLayout><CourseQuestion /></AdminLayout>} />
        <Route path={"/training"} element={<UserLayout><Training /></UserLayout>} />
        <Route path={"/support"} element={<UserLayout><Support /></UserLayout>} />
        <Route path={"/event"} element={<UserLayout><Ticket /></UserLayout>} />
        <Route path={"/certification"} element={<UserLayout><Certification /></UserLayout>} />
        <Route path={"/certification"} element={<Layout><Certification /></Layout>} />
        <Route path={"/couponCode"} element={<AdminLayout><CouponCode /></AdminLayout>} />
        <Route path={"/eventandpayment"} element={<AdminLayout><EventAndPayment /></AdminLayout>} />
        <Route path={"/customized"} element={<AdminLayout><CustomizedPackageOrder /></AdminLayout>} />
        <Route path={"/notification"} element={<AdminLayout><AdminNotification /></AdminLayout>} />
        <Route path={"/unlistedVideo"} element={<Layout><UnlistedVideo /></Layout>} />
        <Route path={"/barcode"} element={<CertificateBarcode />} />
      </Routes>
    </>
  );
}

export default App;
